import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { CreditLetterComponent } from './credit-letter.component';
import { TokenInformationComponent } from './token-information/token-information.component';
import { HowWorksComponent } from './how-works/how-works.component';
import { PanelComponent } from './panel/panel.component';
import { NewComponent } from './new/new.component';
import { ModalRequestComponent } from './modal-request/modal-request.component';

@NgModule({
    declarations: [
        CreditLetterComponent,
        TokenInformationComponent,
        HowWorksComponent,
        PanelComponent,
        NewComponent,
        ModalRequestComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule.forChild([
            {
                path: '',
                component: CreditLetterComponent,
                children: [
                    {
                        path: 'panel',
                        component: PanelComponent
                    },
                    {
                        path: 'new',
                        component: NewComponent
                    },
                    {
                        path: 'view/:id',
                        component: NewComponent
                    },
                    {
                        path: 'edit/:id',
                        component: NewComponent
                    }
                ]
            }
        ])
    ]
})
export class CreditLetterModule { }
